import * as moveInfo from "./moveInfoFn";
import navigationsLinks from "../../../constants/navigation_links";
import {
  getDistanceGoogleAPI,
  getGeoCode,
  getClientTimezone,
  updateOrderData,
  checkPendingOrder,
} from "../../../adapters/estimate/estimateAdapters";
import {
  updateStepToActive,
  thunkClearEstimateData,
} from "../../reducers/storage_progress/progressReducer";
import { updateProgressSession } from "../../reducers/storage_progress/progressFn";

import { compareGeoCodes } from "../../../components/common/validationFn";

import { submitEstimate } from "../../../adapters/estimate/estimateAdapters";
import momentTimeZone from "moment-timezone";
import { verifyOrderInDB } from "../../../functions/helper";
//actions
export const UPDATE_MOVE_INFO = "moveInfo/update";
export const CLEAR_MOVE_INFO = "moveInfo/clear";
export const LOAD_MOVE_INFO = "moveInfo/load";
export const UPDATE_SUBMIT_STATUS = "moveInfo/updateFormSubmitStatus";
export const LOAD_FROM_SESSION = "moveInfo/loadFromLocalSession";
export const LOAD_FROM_URL = "moveInfo/loadFromURL";
// {
//   "storageMoveInfo":{
//       "selectCity":"",
//       "pickupAddress":"",
//       "serviceLiftAvailable":"",
//       "floorNo":"",
//       "pickupDate":"",
//   },
//   "storageInventory":"",
//   "storageProgressInfo":""
// }
//reducers
export default function moveInfoReducer(
  state = moveInfo.getInitState(),
  action = {}
) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_MOVE_INFO:
      return moveInfo.updateMoveInfo(state, payload);
    case CLEAR_MOVE_INFO:
      return moveInfo.getInitState();
    case LOAD_MOVE_INFO:
      return state;
    case UPDATE_SUBMIT_STATUS:
      return moveInfo.updateMoveInfoFormSubmit(state, payload);
    case LOAD_FROM_SESSION:
      return moveInfo.updateFromLocalSession(state, payload);
    case LOAD_FROM_URL:
      return moveInfo.loadStateFromURL(state, payload);
    default:
      return state;
  }
}

//actions creators
export function loadMoveInfoState(data) {
  return { type: LOAD_MOVE_INFO, payload: data };
}
export function updateMoveInfoState(data) {
  return { type: UPDATE_MOVE_INFO, payload: data };
}
export function clearMoveInfoState(data) {
  return { type: CLEAR_MOVE_INFO, payload: data };
}
export function updateFormSubmitStatus(data) {
  return { type: UPDATE_SUBMIT_STATUS, payload: data };
}
export function updateStateFromLocalSession(data) {
  return { type: LOAD_FROM_SESSION, payload: data };
}
export function loadMoveInfoFromURL(payload) {
  return { type: LOAD_FROM_URL, payload: payload };
}
export const collectLeadDetails = async () => {
  // const getFlexibleStatus = 1;
  const userSessionData = JSON.parse(sessionStorage.getItem("userSessionData"));
  const moveInfo = JSON.parse(sessionStorage.getItem("storage_moveinfo"));
  const urlpath = JSON.parse(sessionStorage.getItem("urlpath"));


  const userId = userSessionData.userId;
  const customerName = userSessionData.customerName;
  const clientTimezone = getClientTimezone();

  let pickupDate = new Date(moveInfo.pickup_date);
  pickupDate = momentTimeZone
    .tz(pickupDate, "UTC")
    .format("YYYY-MM-DD HH:mm:ss");
  const fromAddress = {
    firstName: customerName,
    lastName: "",
    fromAddress: moveInfo.pickup_address,
    fromLocality: "",
    fromCity: moveInfo.select_city,
    fromState: "",
    pincode: "",
  };
  const toAddress = {
    firstName: customerName,
    lastName: "",
    toAddress: "Boxigo Storage Service",
    toLocality: "Rampura",
    toCity: "Bengaluru",
    toState: "Karnataka",
    pincode: "562149",
  };
  const body = {
    user_id: userId,
    city_type: "within city",
    select_city: moveInfo.select_city,
    moving_from: moveInfo.pickup_address,
    moving_to: "",
    moving_on: pickupDate,
    distance: "15 Km",
    duration: "1 hrs",
    property_size: "FEW ITEMS",
    move_date_flexible: 1,
    old_floor_no: moveInfo.floor_no,
    new_floor_no: 0,
    old_elevator_availability: "No",
    packing_service: "Yes",
    new_elevator_availability: "No",
    unpacking_service: "No",
    old_parking_distance: 0,
    new_parking_distance: 0,
    old_house_additional_info: "",
    new_house_additional_info: "",
    items: "",
    total_items: 0,
    call_back: 0,
    service_type: "storage",
    client_timezone: clientTimezone,
    from_address: JSON.stringify(fromAddress),
    to_address: JSON.stringify(toAddress),
    created_by: "customer",
    lead_stage: "lead_created",
    exit_lead_stage: "lead_created",
    is_create_relocation: "0",
    days_of_storage: moveInfo.days_of_storage,
    version: "v2",
    lead_source: "website",
    urlpath: urlpath
  };

  const params = body;
  const orderDetails = JSON.parse(
    sessionStorage.getItem("storageOrderDetails")
  );
  if (orderDetails !== null) {
    try {
      params.estimate_id = orderDetails.orderId;
      params.update_type = "storage_move_info";
      const response = await updateOrderData(params);
      if (response.data.code === 200) {
        return { status: true };
      }
    } catch (e) {
      console.error(e);
      // setSubmitProgress(false);
      // setError({
      //   status: true,
      //   message: "OOP's! An Error Occurred, Please try again later.",
      // });
    }
  } else {
    try {
      const pendingOrderResult = await checkPendingOrder({
        user_id: params.user_id,
        service_type: params.service_type,
        city_type: params.city_type || ""
      });

      if (pendingOrderResult.data.data.length === 0) {
        // console.log("second", params)
        const response = await submitEstimate(params);
        if (
          response.data.meta.code === 200 &&
          response.data.meta.status === "OK"
        ) {
          // console.log(response);
          const estimateId = response.data.data.estimate_id;
          const orderDetails = { orderId: estimateId, dateCreated: new Date() };
          sessionStorage.setItem(
            "storageOrderDetails",
            JSON.stringify(orderDetails)
          );
          return { status: true };
        }
      } else {
        const estimateId = pendingOrderResult.data.data[0].estimate_id;
        const orderDetails = {
          orderId: estimateId,
          dateCreated: new Date(pendingOrderResult.data.data[0].date_created),
        };
        sessionStorage.setItem(
          "storageOrderDetails",
          JSON.stringify(orderDetails)
        );
        params.estimate_id = estimateId;
        params.update_type = "storage_move_info";
        const response = await updateOrderData(params);
        if (response.data.code === 200) {
          return { status: true };
        }
        return { status: true };
      }
    } catch (e) {
      console.error(e);
      // setSubmitProgress(false);
      // setError({
      //   status: true,
      //   message: "OOP's! An Error Occurred, Please try again later.",
      // });
    }
  }
};
//action creators which returns functions
export function thunkSubmitMoveInfoForm(payload) {
  return async (dispatch, getState) => {
    dispatch(updateFormSubmitStatus({ status: true }));
    const { data, history } = payload;
    const isOrderOutdated = await verifyOrderInDB("storage");
    if (isOrderOutdated === true) {
      dispatch(thunkClearEstimateData());
      history.push("/storage-services/get-quote");
      return;
    }
    try {
      // data["distance"] = distanceObj.distance;
      // data["duration"] = distanceObj.duration;
      const moveInfoData = moveInfo.prepareRequestData(data);
      sessionStorage.setItem("storage_moveinfo", JSON.stringify(moveInfoData));
      updateProgressSession("step1");
      dispatch(updateMoveInfoState(data));
      dispatch(updateStepToActive({ stepToUpdate: "step1" }));
      await collectLeadDetails();
      dispatch(updateFormSubmitStatus({ status: false }));
      if (payload.gotoPage !== undefined) {
        history.push(payload.gotoPage);
      } else {
        history.push(navigationsLinks.storage_inventory_page);
      }
      dispatch(updateFormSubmitStatus({ status: false }));
    } catch (e) {
      dispatch(updateFormSubmitStatus({ status: false }));

      console.error("Error", e);
    }
    // dispatch(updateMoveInfoState(data));
  };
}
export function thunkLoadMoveInfoFromSession(payload) {
  return (dispath, state) => {
    const moveInfoData = JSON.parse(payload.moveInfo);
    dispath(updateStateFromLocalSession(moveInfoData));
  };
}

export function thunkUpdateMoveInfoFromURL(payload) {
  return (dispatch, state) => {
    dispatch(updateFormSubmitStatus({ status: true }));

    const {
      propertySize,
      movingFrom,
      movingTo,
      movingOn,
      moveType,
      selectCity,
      isFlexible,
    } = payload;
    const getGeographicalData = async () => {
      const distanceObj = await getDistanceGoogleAPI(movingFrom, movingTo);
      const fromGeoCode = await getGeoCode(movingFrom);
      const toGeoCode = await getGeoCode(movingTo);

      const checkResult = compareGeoCodes(fromGeoCode, toGeoCode);
      return {
        distanceMatrix: distanceObj,
        geoCheck: checkResult,
      };
    };
    getGeographicalData()
      .then((geoData) => {
        const payload = {
          moveType: moveType,
          selectCity: selectCity,
          propertySize: propertySize,
          movingFrom: movingFrom,
          movingTo: movingTo,
          movingOn: movingOn,
          distance: geoData.distanceMatrix["distance"],
          duration: geoData.distanceMatrix["duration"],
          isMoveFlexible: isFlexible === "0" ? false : true,
        };
        updateProgressSession("step1");
        const moveInfoData = {
          city_type: moveType,
          distance: payload.distance,
          duration: payload.duration,
          move_date_flexible: true,
          moving_date: payload.movingOn,
          moving_from: payload.movingFrom,
          moving_to: payload.movingTo,
          property_size: payload.propertySize,
          select_city: payload.selectCity,
        };
        sessionStorage.setItem("move_info", JSON.stringify(moveInfoData));
        dispatch(loadMoveInfoFromURL(payload));
        // dispatch(updateFormSubmitStatus({ status: false }));
        // dispatch(updateMoveInfoState(data));
        dispatch(updateStepToActive({ stepToUpdate: "step1" }));
        dispatch(updateFormSubmitStatus({ status: false }));
      })
      .catch((err) => console.error(err));
  };
}
